import Vue from "vue"
import Vuex from "vuex"
import "@firebase/firestore"
import firebase from "firebase/app"
import "firebase/auth"

import chatStore from "./chat"
import identityStore from "./identity"
import partyStore from "./party"
import firebaseConfig from "../../firebase.js"
import firebaseAPI from "@/interface/firebaseServiceLayer"
import API from "@/interface/bleachServiceLayer"

firebase.initializeApp(firebaseConfig)
Vue.use(Vuex)

//////////////////
/// API CONFIG ///
//////////////////

// let HEADER_CONFIG = {
//   Accept: "application/json",
//   "Content-Type": "application/json",
//   "Access-Control-Allow-Origin": "*"
// }

// let API_URL = "https://bleach-chat-api.herokuapp.com/api/v1"

export default new Vuex.Store({
  state: {
    db: firebase.firestore(),
    chatAPI: firebaseAPI(firebase),
    isModLoggedIn: false,
    errors: []
  },

  mutations: {
    setModLoggedIn(state, val) {
      state.isModLoggedIn = val
    },
    setStarted(state, payload) {
      state.partyStarted = payload
    },
    addError(state, payload) {
      state.errors = [...state.errors, payload]
    },
    removeError(state, payload) {
      state.errors = state.errors.filter(err => err.code == payload.code)
    }
  },

  actions: {
    addError({ commit }, err) {
      commit("addError", err)
    },
    removeError({ commit }, err) {
      commit("removeError", err)
    },
    async doModLogin({ commit, state, dispatch }, user) {
      const { success, firebase_creds } = await API.modLogin(
        user.name,
        user.password
      )

      if (success) {
        state.chatAPI
          .authenticate(firebase_creds.username, firebase_creds.password)
          .then(() => {
            dispatch("identityStore/setIdentityFromFirebase", [
              "Bleach London",
              "admin@bleachlondon.com",
              5
            ])
            commit("setModLoggedIn", true)
            return Promise.resolve()
          })
      }
    }
  },

  modules: {
    chatStore,
    identityStore,
    partyStore
  }
})
